import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CAMPAIGNS } from '../constants'

const deleteCampaign = async (id: number) => {
  await fetchAPI({
    path: `/campaigns/${id}`,
    method: 'delete',
  })
}

export const useDeleteCampaign = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteCampaign, {
    async onSuccess() {
      await queryClient.refetchQueries([CAMPAIGNS])

      toast({
        description: t('views.admin.campaigns.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
